import { render, staticRenderFns } from "./InputAktivitas-old.vue?vue&type=template&id=896ca136&scoped=true&lang=html&"
import script from "./InputAktivitas-old.vue?vue&type=script&lang=js&"
export * from "./InputAktivitas-old.vue?vue&type=script&lang=js&"
import style0 from "./InputAktivitas-old.vue?vue&type=style&index=0&id=896ca136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ca136",
  null
  
)

export default component.exports